/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementPrintResultItemListResponse } from './EventManagementPrintResultItemListResponse';

export type EventManagementPrintResultItemListResponseApiRespoonse = {
    data?: EventManagementPrintResultItemListResponse;
    status?: EventManagementPrintResultItemListResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementPrintResultItemListResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

